mutation DeleteHifoCascadePitch($id: ID!) {
  deleteHifoCascadePitch(input: { id: $id }) {
    success
  }
}
